
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/privacy-policy",
      function () {
        return require("private-next-pages/about/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/privacy-policy"])
      });
    }
  